import { cn } from '../../utils/cn'
import { CardRadio } from './CardRadio'

export interface ButtonGroupOption<T> {
  label: string
  value: T
}

interface ButtonGroupProps<T> {
  options: ButtonGroupOption<T>[]
  value: T | null | undefined
  onChange: (value: T) => void
  className?: string
}

/** A single-select toggle rendered as a row of equal-width CardRadios. */
export function ButtonGroup<T>({ options, value, onChange, className }: ButtonGroupProps<T>) {
  return (
    <div className={cn('flex gap-2', className)}>
      {options.map((o) => (
        <CardRadio
          key={String(o.value)}
          className="flex-1"
          isSelected={value === o.value}
          onSelect={() => onChange(o.value)}
        >
          {o.label}
        </CardRadio>
      ))}
    </div>
  )
}

interface YesNoProps {
  value: boolean | null | undefined
  onChange: (value: boolean) => void
  className?: string
}

/** A Yes / No toggle built on ButtonGroup. */
export function YesNo({ value, onChange, className }: YesNoProps) {
  return (
    <ButtonGroup
      options={[
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ]}
      value={value}
      onChange={onChange}
      className={className}
    />
  )
}
